import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from '../config/index';
import axios from 'axios';
console.log(process.env.NODE_ENV);
console.log(config);

export default class checkBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      over65Yrs: false,
      longTermHealthProblems: false,
      HealthRisksNone: false,
      trigger: false,
      activeBox: true
    };

    this.triggetNext = this.triggetNext.bind(this);
  }

  onChange = (checkedState) => event => {
    this.setState(initialState => ({
      [checkedState]: !this.state[checkedState]
    }));

    if(checkedState === "HealthRisksNone" && this.state[checkedState] === true){
      this.setState({
        activeBox: true
      })
    }
    else if(checkedState === "HealthRisksNone" && this.state[checkedState] === false){
      this.setState({
        activeBox: false,
        over65Yrs: false,
        longTermHealthProblems: false,
      })
    }
  }

  getUserData = async(steps) => {
    console.log("steps are: ",steps);
    let language = steps.language ? steps.language.value : 'english';
    let healthData = steps[language + 'HealthRisksQuery'].value.checkbox
    let healthArr = healthData.split(',');

    let userData ={
      userId: "35",
      content: "I have corona virus",
      subtopic: "CoronaVirus",
      dialog: "HealthRisksQuery",
      submit: {}
    }
    if(steps['NameInputQuery'])
      userData.submit['NameInputQuery'] = steps['NameInputQuery'].value;
    if(steps['EmailInputQuery'])
      userData.submit['EmailInputQuery'] = steps['EmailInputQuery'].value; 
    if(steps['PhoneInputQuery']) 
      userData.submit['PhoneInputQuery'] = steps['PhoneInputQuery'].value; 
    if(steps['CorporateNameQuery'])
      userData.submit['CorporateNameQuery'] = steps['CorporateNameQuery'].value; 
    if(steps[language + 'SymptomsQuery'])
      userData.submit['SymptomsQuery'] = steps[language + 'SymptomsQuery'].value;
    if(steps[language + 'TravelExposureQuery'])
      userData.submit['TravelExposureQuery'] = steps[language + 'TravelExposureQuery'].value;
    if(steps[language + 'CaseExposureQuery'])
      userData.submit['CaseExposureQuery'] =steps[language + 'CaseExposureQuery'].value;
    if(steps['ContainmentAreaQuery'])
      userData.submit["ContainmentAreaQuery"] = steps['ContainmentAreaQuery'].value;
    if(steps["DisorderQuery"])
      userData.submit["DisorderQuery"] = steps["DisorderQuery"].value;
    if(steps["SuppressantDisorderQuery"])
      userData.submit["SuppressantDisorderQuery"] = steps["SuppressantDisorderQuery"].value;
    if(steps[ "DrugQuery"])
      userData.submit[ "DrugQuery"] = steps[ "DrugQuery"].value;
    if(steps["MassGatheringQuery"])
      userData.submit["MassGatheringQuery"] = steps["MassGatheringQuery"].value;
    if(steps["TravelQuery"])
      userData.submit["TravelQuery"] = steps["TravelQuery"].value;

    for(let i=0; i < healthArr.length; i++){
      if(healthArr[i] === "over65Yrs"){
        userData.submit[healthArr[i]] = this.props.checkBoxData.ch1;
      }
      else if(healthArr[i] === "longTermHealthProblems"){
        userData.submit[healthArr[i]] = this.props.checkBoxData.ch2;
      }
      else if (healthArr[i] === "HealthRisksNone"){
        userData.submit[healthArr[i]] = this.props.checkBoxData.ch3;
      }
    }
    
    return userData;

  }

  sendUserData = async(steps) => {

    let userData = await this.getUserData(steps);
    let tempData = userData.submit;
    userData['submit'] = JSON.stringify(tempData);
    localStorage.setItem("language", steps.language ? steps.language.value : 'english');

    console.log(userData);

    try {
      let response = await axios({
        method: 'post',
        url: 'https://chatbotbackend.docsapp.in/chatbot/chat',
        data: userData
      });
      localStorage.setItem("summary", response.data.endSummary)
      window.location.assign('#result');
    } catch (error) {
      console.error(error);
    }

  }

  onSubmit = async (e) => {
    e.preventDefault();

    let checkArray = [];
    for (var key in this.state) {
      if (this.state[key] === true) {
        checkArray.push(key);
      }
    }

    let checkData = {
      checkbox: checkArray.toString()
    };
    
    const { steps } = this.props;
    let language = steps.language ? steps.language.value : 'english';
    steps[language + 'HealthRisksQuery'].value = checkData;

    await this.sendUserData(steps);

    this.triggetNext();
  }

  triggetNext() {
    this.setState({ trigger: true }, () => {
      this.props.triggerNextStep();
    });
  }

  componentDidMount() {
    console.log(this.props.checkBoxData);
  }

  render() {
    return (
    <div style={{backgroundColor: "#D7FFCC", padding: "inherit",}}>
      <form onSubmit={this.onSubmit}>
          
          {(this.props.checkBoxData.ch1) ? (<div className="form-check">
            <label className="form-check-label">
            <p style={{'fontWeight': '350', 'fontSize': '16px'}}>
              <input type="checkbox"
                checked={this.state.over65Yrs}
                onChange={this.onChange('over65Yrs')}
                className="form-check-input"
                disabled={!this.state.activeBox}
              />
              {this.props.checkBoxData.ch1}</p>
            </label>
          </div>) : ''}
          
          <div className="form-check" >
            <label className="form-check-label">
            <p style={{'fontWeight': '350', 'fontSize': '16px'}}>
              <input type="checkbox"
                checked={this.state.longTermHealthProblems}
                onChange={this.onChange('longTermHealthProblems')}
                className="form-check-input"
                style={{borderRadius: '25px'}}
                disabled={!this.state.activeBox}
              />
              {this.props.checkBoxData.ch2}
              </p>
            </label>
          </div>

          <div className="form-check" >
            <label className="form-check-label">
            <p style={{'fontWeight': '350', 'fontSize': '16px'}}>
              <input type="checkbox"
                checked={this.state.HealthRisksNone}
                onChange={this.onChange('HealthRisksNone')}
                className="form-check-input"
                style={{borderRadius: '25px'}}
              />
              {this.props.checkBoxData.ch3}
              </p>
            </label>
          </div>


          <div className="form-group">
            <button className="btn btn-success" style={{width:'100px',height: '45px',backgroundColor: '#4CAF50', border: 'none', color: 'white', padding: '0px 10px', textAlign: 'center', display: 'inline-block', fontSize: '16px', margin: '4px 2px', cursor: 'pointer', borderRadius: '30px', paddingTop:'9px'}}>
            <p style={{'fontWeight': 'bold', 'fontSize': '16px'}}>
            {this.props.checkBoxData.sub}
            </p>
            </button>
          </div>
        </form>
    </div>
    );
  }
}

checkBox.propTypes = {
  steps: PropTypes.object,
  triggerNextStep: PropTypes.func
};

checkBox.defaultProps = {
  steps: undefined,
  triggerNextStep: undefined
};